import { __assign, __rest } from "tslib";
import React, { useState } from "react";
import { colors, theme } from "../../theme";
import { RoundedToggleButton } from "./RoundedToggleButton";
import { faCaretUp, faCaretDown, faCirclePlus, faCircleMinus } from "@fortawesome/sharp-solid-svg-icons";
import { IconButton } from "./IconButton";
import { Button } from "./Button";
import { styled } from '@mui/material/styles';
import { FlexRow } from "../layout/FlexRow";
import { Switch } from "@mui/material";
var MyDiv = styled('div')({
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
        width: '4px'
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: colors.gray[10],
        borderRadius: '3px'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: colors.gray[50],
        borderRadius: '3px'
    }
});
export var IamRolesCard = function (_a) {
    var _b = _a.expandable, expandable = _b === void 0 ? true : _b, icon = _a.icon, _c = _a.buttonType, buttonType = _c === void 0 ? "button" : _c, _d = _a.showOpenButton, showOpenButton = _d === void 0 ? true : _d, _e = _a.selected, selected = _e === void 0 ? false : _e, _f = _a.assigned, assigned = _f === void 0 ? false : _f, title = _a.title, description = _a.description, _g = _a.isCheckedSwitch, isCheckedSwitch = _g === void 0 ? false : _g, onChangeSwitch = _a.onChangeSwitch, onClickButtonTopRight = _a.onClickButtonTopRight, onClickActionButton = _a.onClickActionButton, onClickOpen = _a.onClickOpen, onClickButtonBottomLeft = _a.onClickButtonBottomLeft, style = _a.style, _h = _a.showMoreButton, showMoreButton = _h === void 0 ? true : _h, children = _a.children, _j = _a.width, width = _j === void 0 ? '100%' : _j, props = __rest(_a, ["expandable", "icon", "buttonType", "showOpenButton", "selected", "assigned", "title", "description", "isCheckedSwitch", "onChangeSwitch", "onClickButtonTopRight", "onClickActionButton", "onClickOpen", "onClickButtonBottomLeft", "style", "showMoreButton", "children", "width"]);
    var _k = useState(false), expanded = _k[0], setExpanded = _k[1];
    return (React.createElement("div", __assign({ style: __assign({ 
            //  width: '605px',
            width: width, minWidth: '300px', 
            //maxWidth: '605px',
            minHeight: '72px', height: expanded ? 'fit-content' : '72px', backgroundColor: selected ? colors.gray[5] : colors.white, borderWidth: '1px', borderColor: colors.gray[20] || '#D8DDE4 !important', borderRadius: '8px', borderStyle: 'solid', paddingTop: '14px', paddingBottom: expanded ? '16px' : '12px', paddingLeft: '24px', paddingRight: '16px', display: 'flex', justifyContent: 'space-between', fontFamily: theme.font.body.regular.fontFamily, fontSize: theme.font.body.regular.fontSize, fontWeight: theme.font.body.regular.fontWeight, color: theme.font.body.regular.color }, style) }, props), /** EXPANDED RENDER */ expanded ?
        React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                width: '100%',
                height: '100%'
            } },
            React.createElement("div", null,
                React.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'space-between'
                    } },
                    React.createElement(FlexRow, { columnGap: "7px" },
                        icon,
                        React.createElement("div", { style: __assign(__assign({}, theme.font.body.semiBold), { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', 
                                // width: '400px',
                                //width: '100%',
                                textAlign: 'left' }) }, title)),
                    buttonType === 'button' ?
                        React.createElement(IconButton, { style: { alignSelf: 'start' }, icon: assigned ? faCircleMinus : faCirclePlus, variant: assigned ? 'gray' : 'grayBlue', size: 'sm', onClick: onClickActionButton })
                        : buttonType === 'switch' ?
                            React.createElement(Switch, { sx: {
                                    position: 'relative',
                                    left: '0px'
                                }, 
                                // size="small"
                                onChange: onChangeSwitch, checked: isCheckedSwitch })
                            :
                                null),
                React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%'
                    } },
                    React.createElement("div", { style: __assign(__assign({}, theme.font.caption.regular), { textAlign: 'left' }) }, description),
                    React.createElement(MyDiv, { style: __assign(__assign({}, theme.font.caption.regular), { width: '100%', height: 'fit-content', maxHeight: '280px', 
                            //height: '100px',
                            paddingRight: '100px', textAlign: 'left' }) }, children))),
            React.createElement("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    justifySelf: 'flex-end',
                    //width: '509px',
                    width: '100%'
                } },
                showOpenButton ?
                    React.createElement(Button, { variant: "grayBlue", size: "sm", onClick: onClickOpen }, "Open in new tab")
                    :
                        React.createElement("div", null),
                expandable && showMoreButton ?
                    React.createElement(RoundedToggleButton, { icon: expanded ? faCaretUp : faCaretDown, label: expanded ? 'Less' : 'More', onClick: function () { return setExpanded(function (prevState) { return !prevState; }); }, style: {
                            marginRight: expanded ? '54px' : '0px'
                        } })
                    :
                        null))
        : // NOT EXPANDED (COLLAPSED)
            React.createElement("div", { style: {
                    height: '34px',
                    width: '100%',
                    display: 'flex',
                    flex: 4,
                    justifyContent: 'space-between',
                    columnGap: '10px'
                } },
                icon,
                React.createElement("div", { style: {
                        display: 'flex',
                        flex: 3,
                        flexDirection: 'column',
                        width: '100%',
                        minWidth: '130px'
                    } },
                    React.createElement("div", { style: __assign(__assign({}, theme.font.body.semiBold), { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '130px', textAlign: 'left', marginLeft: icon ? '7px' : 'initial' }) }, title),
                    React.createElement("div", { style: __assign(__assign({}, theme.font.caption.regular), { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '130px', textAlign: 'left', marginLeft: icon ? '7px' : 'initial' }) }, description)),
                React.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'flex-end',
                        flex: 1,
                        gap: '10px',
                        alignItems: 'flex-end',
                        position: 'relative'
                    } },
                    expandable && showMoreButton ?
                        React.createElement(RoundedToggleButton, { icon: expanded ? faCaretUp : faCaretDown, label: expanded ? 'Less' : 'More', onClick: function () { return setExpanded(function (prevState) { return !prevState; }); } })
                        :
                            React.createElement("div", { style: { width: '60px' } }),
                    buttonType === "button" ?
                        React.createElement(IconButton, { style: { alignSelf: 'start' }, icon: assigned ? faCircleMinus : faCirclePlus, variant: assigned ? 'gray' : 'grayBlue', size: 'sm', onClick: onClickActionButton })
                        : buttonType === "switch" ?
                            React.createElement(Switch, { sx: {
                                    position: 'relative',
                                    top: '0px',
                                    float: 'right'
                                }, 
                                // size="small"
                                onChange: onChangeSwitch, checked: isCheckedSwitch })
                            :
                                null))));
};
